import { CATEGORY_ID } from '../constants/categoryId';

const RESPINABLE = [CATEGORY_ID.FRESH_FROZEN_PLASMA];

export function isRespinable(categoryId: number) {
  return RESPINABLE.includes(categoryId);
}
